// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import Storage from 'vue-ls'; //缓存插件 可用于设置缓存过期时间
import router from './router';
import store from '@/store';
// import Storage from 'Vue-web-storage';
import less from 'less';
import Router from 'vue-router';
import 'es6-promise/auto';
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import Base64 from '@/common/base64.js';
Vue.prototype.$Base64 = Base64;
//引入cookies组件
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);

Vue.prototype.$video = Video;
Video.Hls.xhr.beforeRequest = function (options) { //添加请求头token
    // options.uri = options.uri +"?_t="+ new Date().getTime(); //添加请求参数
    options.uri = options.uri;
    options.headers = options.headers || {};
    // options.headers.token = Vue.prototype.$cookies.get("JT_S_02_token");
    options.headers.token = getCookieForRoleTag();
    options.headers["_role_tag"] = getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null;
    return options;
};
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(less);


/*引入element组件*/
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.config.productionTip = false;

import * as util from '@/common/ulit';
// 全局方法加载
import {post, get} from '@/common/request';
// 路径定义
import APIDOC from '@/common/serverApi';
import {getCookieForRoleTag} from "./common/ulit";

Vue.prototype.$baseUrl = APIDOC.BASEURL;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
if(getCookieForRoleTag() != null) {
    store.dispatch('getPayConfigStatus');
}

for (const [k, v] of Object.entries(util)) {
    Vue.filter(k, v);
    Vue.prototype[`$${k}`] = v;
}


//缓存插件
const options = {
    namespace: 'vuejs__', // 存储的key的前缀
    name: 'ls', // 命名，Vue变量.[ls]或this.[$ls]。全局：Vue.ls，上下文：this.$ls
    storage: 'local', //  存储名称【三个可选项】:session, local, memory
};

Vue.use(Storage, options);

// Vue.use(Storage, {
//   prefix: 'your_app_slug_', // default `app_`
//   drivers: ['session', 'local'] // default 'local'
// });

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js